import styled from 'styled-components';
// components
import Icon from 'cds/icons';
import TextButton from 'cds/buttons/Text';
// styles
import * as typography from 'cds/typography';
import { palette, mediaQuery, zIndex } from 'cds/styles';
// utils
import { formatToPrice } from 'lib/utils/format/number';

/**
 * 클래스 필더 헤더
 * @param {object} props
 * @param {number} props.classTotalCount 클래스 총 개수
 * @param {string} props.sortName 선택된 정렬
 * @param {Function} props.onClickSort 정렬 버튼 클릭 함수
 */
const ClassFilter = ({ classTotalCount, sortName, onClickSort, children }) => {
  return (
    <Layout>
      <ResultCount>{`클래스 ${formatToPrice(classTotalCount)}개`}</ResultCount>

      <SortButton onClick={onClickSort}>
        <Icon name="ic_filter" stroke={palette.grey50} width={16} height={16} />
        {sortName}
      </SortButton>

      {children}
    </Layout>
  );
};

const Layout = styled.div`
  position: sticky;
  width: 100vw;
  top: 55px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 44px;
  padding: 0 16px;
  border-style: solid;
  border-width: 1px 0;
  border-color: ${palette.system.BNB};
  background-color: ${palette.system.BG};
  z-index: ${zIndex.header};

  ${mediaQuery.large} {
    position: relative;
    top: 0;
    z-index: 1;
    width: 100%;
    padding: 0;
    margin-left: 0;
    border: none;
    background-color: transparent;
    justify-content: flex-start;
    border-color: ${palette.system.grey};
  }
`;

const ResultCount = styled.span`
  ${typography.body3_regular}
  color: ${palette.grey50};

  ${mediaQuery.large} {
    height: 40px;
    padding: 10px 16px;
    border-radius: 4px;
    background-color: ${palette.BTN.BG};
    color: ${palette.grey50};
  }
`;

const SortButton = styled(TextButton)`
  flex-grow: 0;
  height: 32px;
  padding: 0 16px;
  ${typography.caption2_medium};
  color: ${palette.grey50};
  background-color: ${palette.BTN.BG};

  & svg {
    display: block;
    margin-right: 4px;
  }

  ${mediaQuery.large} {
    display: none;
  }
`;

export default ClassFilter;
